import { Route, Routes } from 'react-router-dom'

import InteractionContainer from 'modules/interaction/containers/InteractionContainer'
import GenericErrorPage from 'modules/interaction/components/GenericErrorPage'

const Router = () => (
  <Routes>
    <Route path='/:id_interaction_model' element={<InteractionContainer />} />
    <Route path='*' element={<NoMatch />} />
  </Routes>
)

const NoMatch = () => {
  return <GenericErrorPage />
}

export default Router
